import { Button } from '@design-system';
import { formatCurrency } from '@shared';
import { splitAssets } from './partner-funding-utils';

interface MirroredSourceStatusProps {
  clientName: string;
  partnerName: string;
  splitRatio: number | null;
  totalAssets: number;
  onUnlink: () => void;
}

const formatAmount = (value: number) => formatCurrency(value, 0);

export function MirroredSourceStatus({
  clientName,
  partnerName,
  splitRatio,
  totalAssets,
  onUnlink,
}: MirroredSourceStatusProps) {
  const amounts = splitRatio != null ? splitAssets(totalAssets, splitRatio) : null;

  return (
    <div className="border-primary/30 bg-primary/5 space-y-3 rounded-lg border p-3.5">
      <div className="flex items-center justify-between">
        <div className="flex flex-col gap-1">
          <span className="text-sm font-medium text-gray-950">
            {splitRatio != null
              ? `Split ${splitRatio}/${100 - splitRatio} with ${partnerName}`
              : `Mirrored with ${partnerName}'s plan`}
          </span>
          <span className="text-muted-foreground text-sm">
            Changes to this account will sync to {partnerName}&apos;s plan
          </span>
        </div>
        <Button
          variant="outline"
          size="sm"
          onClick={onUnlink}
        >
          Unlink
        </Button>
      </div>
      {amounts && (
        <div className="grid grid-cols-2 gap-3">
          <div className="rounded-lg bg-white/60 px-3 py-2">
            <span className="text-muted-foreground text-xs">{clientName}&apos;s share</span>
            <p className="text-sm font-semibold tabular-nums">
              {formatAmount(amounts.clientAmount)}
            </p>
          </div>
          <div className="rounded-lg bg-white/60 px-3 py-2">
            <span className="text-muted-foreground text-xs">
              {partnerName}&apos;s share
            </span>
            <p className="text-sm font-semibold tabular-nums">
              {formatAmount(amounts.partnerAmount)}
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
